import React from "react";

export default function SearchHubCard({ onPress }) {
  return (
    <button
      type="button"
      onClick={onPress}
      className="p2-search-hub"
    >
      <span className="p2-search-hub-icon">
        🔍
      </span>
      <div className="p2-search-hub-text">
        <p className="p2-search-hub-title">
          Kërko mjek ose simptomë
        </p>
        <p className="p2-search-hub-sub">
          p.sh. “dhimbje mesi”, “kardiolog”, “dentist”
        </p>
      </div>
    </button>
  );
}
